import React, { useEffect, useRef, useState } from "react";
import "../Style/Uiux.css";
import "../Style/Uiuxservice.css";
import "../Style/Uiuxdesign.css";

import ServicesSection from "../components/Uiuxservice";
import DesignSection from "../components/Uiuxdesign";
import QaSection from "../components/Uiuxqa";
import StackSection from "../components/Uiuxstack";
import FutureSection from "../components/Uiuxfuture";
import FormSection from "../components/Forms";
import DoubtSection from "../components/Uiuxdoubts";
import ClientSection from "../components/Clientfeedback";
import FooterSection from "../components/Footer";
import LetsBuild from "../components/LetsBuild";

function UIUXPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="uiux-page">
        {/* CSS-only pattern layers, no images */}
        <div className="uiux-grid-pattern" aria-hidden="true" />
        <div className="uiux-blob uiux-blob-1" aria-hidden="true" />
        <div className="uiux-blob uiux-blob-2" aria-hidden="true" />
        <div className="uiux-blob uiux-blob-3" aria-hidden="true" />

        <div
          className={`uiux-overlay ${isVisible ? "uiux-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="uiux-glass">
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="uiux-logo uiux-anim uiux-anim-1"
            /> */}

            <span className="uiux-eyebrow uiux-anim uiux-anim-2">
              UI/UX Design Services
            </span>

            <h1 className="uiux-title uiux-anim uiux-anim-3">
              Design Services That Create Exceptional Digital Experiences
            </h1>

            <p className="uiux-description uiux-anim uiux-anim-4">
              Transform your ideas into intuitive, visually engaging, and
              user-centric digital products with MPeoples. Our UI/UX design
              experts craft seamless experiences that improve usability,
              strengthen brand identity, and increase customer engagement
              across websites, mobile applications, SaaS platforms, and
              enterprise software.
            </p>

            <button className="uiux-btn uiux-anim uiux-anim-5">
              Start Your UI/UX Project <span>→</span>
            </button>
          </div>
        </div>
      </section>

      <ServicesSection />
      <DesignSection />
      <QaSection />
      <StackSection />
      <FutureSection />
      <FormSection />
      <DoubtSection />
      <ClientSection />
      <FooterSection />
    </>
  );
}

export default UIUXPage;